// Keep byte-for-byte identical with the mobile copy (CI diffs them); primitives only, no imports.

// Literals mirror ComponentDataContentType members (kept inline to stay import-free).
// FallBackResponse carries its text in contentData; BasicAiChat's text is aiComment.
const CONTENT_DATA_TEXT_TYPES = ["FallBackResponse"];
const TEXT_ONLY_TYPES = ["FallBackResponse", "BasicAiChat"];

export interface AssistantResponseText {
    aiComment: string | null | undefined;
    aiVocalText: string | null | undefined;
    contentType: string;
    contentData: unknown;
}

export interface AssistantTextBubbles {
    commentText: string;
    contentText: string;
    showEmptyReply: boolean;
    emptyReplyText: string;
}

export const resolveAssistantTextBubbles = ({
    aiComment,
    aiVocalText,
    contentType,
    contentData,
}: AssistantResponseText): AssistantTextBubbles => {
    const commentText = (aiComment ?? "").trim();
    const contentText =
        CONTENT_DATA_TEXT_TYPES.includes(contentType) &&
        typeof contentData === "string"
            ? contentData.trim()
            : "";
    const showEmptyReply =
        TEXT_ONLY_TYPES.includes(contentType) && !commentText && !contentText;

    return {
        commentText,
        contentText,
        showEmptyReply,
        emptyReplyText: showEmptyReply ? (aiVocalText ?? "").trim() : "",
    };
};
